export const envDevelopment = {
  API_URL: 'http://localhost:1000/',
  SERVER_URL: 'http://localhost:1000/',
  SOCKET_URL: 'http://localhost:1003',
  ENV: 'development',
  STRIPE_KEY:
    'pk_test_51LCrqTHiVQXLVsACdjdWnsVvYpOT54Y8kACQwKZ3rmOKpv0cjUQ03skcihoTI3RIr8Xml7spbltIZaec9qpUeeZq00diannqIM',
};
